<div class="ne-note-editor" data-test-page="edit">
  <div class="ne-editor-modal">
      <div class="ne-container">
        <Editor
          overLineLimit={$store.overLineLimit}
          fontSize={$store.fontFace.size.state}
          fontFamily={$store.fontFace.family.state}
          fontWeight={$store.fontFace.weight.state}
          text={$store.getText}
          setText="{event => setText(event)}"
          toggleMessageModal="{toggleMessageModal}"/>
        <EditorFooter
          forwardText="Preview Note"
          backText=""
          canNotSaveEdits={forwardDisabled}
          save="{saveEdits}" />
      </div>
    </div>
    <div class="ne-hide">
      <NotePreview />
    </div>
</div>

<style>
  .ne-note-editor{
    box-sizing: border-box;
  }

  .ne-note-editor :global(*),
  .ne-note-editor :global(*):before,
  .ne-note-editor :global(*):after {
    box-sizing: inherit;
  }

  .ne-note-editor {
    position: relative;
    width: 100%;
    min-width: 380px;
    height: 100%;

    display: grid;
    grid-template-columns: 1fr 300.14px 1fr;
    grid-template-rows: auto 0.5em 420.67px 0.333em auto;

    -ms-grid-columns: 1fr 300.14px 1fr;
  }

  .ne-editor-modal {
    box-sizing: border-box;
  }

  .ne-editor-modal :global(*),
  .ne-editor-modal :global(*):before,
  .ne-editor-modal :global(*):after {
    box-sizing: inherit;
  }

  .ne-editor-modal {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 1.5em;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .ne-container {
    height: 100%;
    width: 100%;
    position: relative;
  }
  
  /* this hidden container is a hacky solution to be able to 
  calculate the number of remaining lines now that the preview 
  and editor are on separate pages. we should consider a 
  different approach as we continue to refactor SAS flow. */
  .ne-hide {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
</style>

<script>
  import Nav from '../components/Nav.html';
  import EditorModal from '../components/EditorModal.html';
  import Editor from '../components/Editor.html';
  import EditorFooter from '../components/EditorFooter.html';
  import NotePreview from '../components/NotePreview.html';
  import { store, history, photo, phraseFilter, router } from '../stores';
  import { stripSpecialCharacters, capitalize } from '../lib/text-utils';
  
  $: disabledByLayout = $store.layout.state === 'photo'
      ? !$photo.hasPhoto
      : !$store.hasText;

  $: disabledByPrintability = $store.overLineLimit;

  $: forwardDisabled = disabledByLayout || disabledByPrintability;

  function toggleMessageModal() {
    store.set($store.isChoosingMessage.toggle());
  };

  function saveEdits() {
    detectProfanity();
    const { cleanedText } = stripSpecialCharacters($store.getText);
    history.set($history.track($store));
    const text = phraseFilter.clean(cleanedText);
    store.set($store.setText(text));
    router.set($router.to('confirm'));
  };

  function setText(text) {
    store.set($store.setText(text));
  };

  function detectProfanity() {
    const command = phraseFilter.hasPhrase($store.getText)
      ? (!$store.hasProfanityWarning
        ? 'addProfanityWarning'
        : false)
      : 'clearProfanityWarnings';

    if (command) { store.set($store[command]()); }
  };

</script>
